module.exports = __webpack_public_path__ + "media/park.e3c96a58.jpg";